import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthRoutes } from './auth/auth.routes';
import { AuthGuard } from './auth/services/auth.guard';
import { PagesRoutes } from './layout/pages.routes';
import { QuoteRoutes } from './quote/quote.routes';

const routes: Routes = [
  {
    path: AuthRoutes.ROUTES.Login.path,
    loadChildren: () => import('./auth/auth.module').then((m) => m.AuthModule),
  },
  {
    path: AuthRoutes.ROUTES.LoginMx.path,
    loadChildren: () => import('./auth/auth.module').then((m) => m.AuthModule),
  },
  {
    path: AuthRoutes.ROUTES.LoginBr.path,
    loadChildren: () => import('./auth/auth.module').then((m) => m.AuthModule),
  }, {
    path: AuthRoutes.ROUTES.LoginPe.path,
    loadChildren: () => import('./auth/auth.module').then((m) => m.AuthModule),
  },
  {
    path: PagesRoutes.ROUTES.Home.path,
    canLoad: [AuthGuard],
    loadChildren: () => import('./layout/artico/artico.module').then((m) => m.ArticoModule),
  },
  {
    path: 'multiproduct',
    canLoad: [AuthGuard],
    loadChildren: () => import('./multi_product/mp.module').then((m) => m.MultiProductModule),
  },
  {
    path: 'public',
    loadChildren: () => import('./auth/auth.module').then((m) => m.AuthModule),
  },
  {
    path: '',
    canLoad: [AuthGuard],
    loadChildren: () => import('./pages/page.module').then((m) => m.PageModule),
  },
  {
    path: '**',
    redirectTo: AuthRoutes.ROUTES.Login.path,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
